export default {
    "pagecategories": {
        "titles": "Categorias",
        "title": "Categoria",
        "model": {
            "name": "Nome",
            "description": "Descrição",
            "locale": "Língua",
            "status": "Ativo",
            "roles": "Perfis de Acesso",
        },
        "list": {
            "name": "@:pagecategories.model.name",
            "description": "@:pagecategories.model.description",
            "locale": "@:pagecategories.model.locale",
            "status": "@:pagecategories.model.status",
        },
        "help": {
            "roles": "Perfil de acesso à categoria, por defeito é público."
        }
    },
    "pages": {
        "titles": "Páginas",
        "title": "Página",
        "model": {
            "title": "Titulo",
            "content": "Conteúdo",
            "category": "Categoria",
            "locale": "Língua",
            "sidebar": {
                "title": "Painel Lateral",
                "show": "Mostrar",
            },
            "label": "Label",
            "icon": "Icon",
            "default": "Página Inicial",
            "order": "Ordem",
            "status": "Ativo",
            "roles": "Perfis de Acesso",
        },
        "list": {
            "order": "@:pages.model.order",
            "title": "@:pages.model.title",
            "label": "@:pages.model.label",
            "sidebar": "@:pages.model.sidebar.title",
            "locale": "@:pages.model.locale",
            "status": "@:pages.model.status",
        },
        "help": {
            "order": "Ordem de apresentação.",
            "roles": "Perfil de acesso à página, por defeito é público."
        }
    },
}
